// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__29NbD","buttons":"SendReceipts_buttons__2yHSX","email":"SendReceipts_email__ksI_0","bookApptTitle":"SendReceipts_bookApptTitle__200wk"};